import * as React from 'react';

const SvgPhoto = (props) => (
  <svg
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='M42 14a3.834 3.834 0 0 1-3.384-2.077l-1.68-3.383c-1.074-2.123-3.874-3.873-6.254-3.873H25.34c-2.403 0-5.203 1.75-6.277 3.873l-1.68 3.383A3.834 3.834 0 0 1 14 14c-5.063 0-9.077 4.27-8.75 9.31l1.213 19.273c.28 4.807 2.87 8.75 9.31 8.75h24.454c6.44 0 9.006-3.943 9.31-8.75l1.213-19.273C51.076 18.27 47.062 14 42 14Zm-17.5 2.917h7c.956 0 1.75.793 1.75 1.75 0 .956-.794 1.75-1.75 1.75h-7c-.958 0-1.75-.794-1.75-1.75 0-.957.792-1.75 1.75-1.75ZM28 42.28c-4.34 0-7.888-3.523-7.888-7.887A7.877 7.877 0 0 1 28 26.507a7.877 7.877 0 0 1 7.887 7.886c0 4.364-3.547 7.887-7.887 7.887Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgPhoto;
